// Module
var code = "<div class=\"la-ball-clip-rotate la-dark\"><div></div></div>";
// Exports
module.exports = code;